import { Suspense, lazy } from 'react'
import { Route, Routes } from 'react-router-dom'

import LazyRouteBoundary from 'Components/Common/LazyRouteBoundary'

import Homepage from './Homepage'

/**
 * The app's route table.
 *
 * This used to live inside `Homepage`, which meant the reviewer flow WAS the
 * app. It was lifted out so a second, unrelated public surface — Content
 * Collect's guest flow — can mount as a sibling without the reviewer component
 * knowing anything about it. `Homepage` is now purely the `review/*` element;
 * its behaviour is unchanged.
 *
 * The collect subtree is the app's first route-level lazy chunk. It is loaded
 * with `React.lazy` so a reviewer never downloads the contributor flow: nothing
 * under `src/collect/` or `src/api/collect/` may be imported statically from
 * the reviewer entry, or the split silently collapses.
 */
const CollectApp = lazy(() => import('./collect/CollectApp'))

const InvalidLink = () => (
  <div
    style={{
      margin: '10px',
      fontSize: '14px',
    }}
  >
    Invalid link, the correct link pattern should be /review/:review-key
  </div>
)

const AppRoutes: React.FC = () => (
  <Routes>
    <Route element={<InvalidLink />} path="/" />
    <Route element={<Homepage />} path="review/*" />
    <Route
      element={
        <LazyRouteBoundary>
          <Suspense
            fallback={
              <div className="flex min-h-screen items-center justify-center">
                <p className="text-sm text-neutral-600" role="status">
                  Loading…
                </p>
              </div>
            }
          >
            <CollectApp />
          </Suspense>
        </LazyRouteBoundary>
      }
      path="collect/*"
    />
  </Routes>
)

export default AppRoutes
